<template>
  <div class='faq-ques-listing-wrapper' v-if="selectedFaq && Object.keys(selectedFaq).length" :class="{'customised-prod-faqs' : callerComp === 'customised-prod-faqs'}">
    <faq-tab :pid="`question-wrapper-${selectedFaqIndex}`">
      <faq-tabcontent v-for="(faq, index) in selectedFaq && selectedFaq.menu_items" :title="faq.question" :key="index" :index="index" :class="index === selectedFaq.menu_items.length-1 ? 'last-card' : ''" :dparent="`question-wrapper-${selectedFaqIndex}`" areaExpanded="false" :isOpen="false">
        <div class="faq-content" v-html="faq.answer">
        </div>
      </faq-tabcontent>
    </faq-tab>
  </div>
</template>
<script>
  var faqtab = {
    props: ['pid'],
    template: '<div  :id="pid" role="tablist" aria-multiselectable="true" class="custaccordian"><slot></slot></div>'
  }
  import faqTabcontent from './faqTab.vue'
  export default {
    components: {faqTabcontent, 'faq-tab': faqtab},
    props: ['selectedFaq', 'selectedFaqIndex', 'callerComp']
  }
</script>
<style scoped>
  ul.coloredlistype li {
    margin-bottom: 8px;
  }

  .custaccordian .card-header a {
    padding: 20px 0;
    text-transform: inherit;
  }
  .customised-prod-faqs .custaccordian .card-header a{
    padding: 15px 0 !important
  }

  .custaccordian .card-block {
    padding: 5px 0px 20px 0;
  }

  .custaccordian .card-block .faq-content {
    color: #58595b;
  }
  .customised-prod-faqs .custaccordian .card-block .faq-content {
    color:#686d6d;
  }

  .custaccordian .card-header a[aria-expanded="true"]::before {
    color: #117a7a;
    top: 10px;
  }
</style>



// WEBPACK FOOTER //
// faqsQuestionsListing.vue?ee96a118